// 'Credit notes' worklist (Sales > Invoices): pure helpers over GET /sales-invoices/credit-notes rows. Money = exact text, sums in cents.
import { cents, sumText } from './invoicingModel.mjs';

export const CREDIT_QUICK = ['has_draft', 'no_draft', 'wont_issue', 'cancelled', 'stranded'];
export const CREDIT_QUICK_TONES = { has_draft: 'info', no_draft: 'warn', wont_issue: 'mut', cancelled: 'crit', stranded: 'warn' };
// Cancelled and Stranded are REGISTER views (Block 8d: GET /sales-documents-register), not worklist filters: they swap the list like Won't issue and leave the worklist semantics alone
export const REGISTER_VIEWS = { cancelled: ['cancelled'], stranded: ['draft'] };   // view -> register status[]
export const registerViewOf = (quick) => (quick || []).find(k => REGISTER_VIEWS[k]) || null;
export const isWontIssueView = (quick) => (quick || []).includes('wont_issue');
// 'Won't issue' and the register views are EXCLUSIVE (they swap the list); the draft chips are OR-composed
export const toggleCreditQuick = (quick, k) => (quick.includes(k) ? quick.filter(x => x !== k) : (k === 'wont_issue' || REGISTER_VIEWS[k]) ? [k] : [...quick.filter(x => x !== 'wont_issue' && !REGISTER_VIEWS[x]), k]);
export function filterCreditRows(rows, { q = '', partner_ids = [], quick = [] } = {}) {
  let r = rows || [];
  const s = q.trim().toLowerCase();
  if (s) r = r.filter(x => String(x.operation_id).toLowerCase().includes(s) || String(x.customer_name || '').toLowerCase().includes(s));
  if (partner_ids.length) r = r.filter(x => partner_ids.includes(x.partner_id));
  const draftQ = quick.filter(k => k === 'has_draft' || k === 'no_draft');
  if (draftQ.length) r = r.filter(x => draftQ.some(k => (k === 'has_draft') === !!x.draft));
  return r;
}
export const creditEvents = (r) => (r.events_open || 0) + (r.events_on_draft || 0);
export function creditTotals(rows) {
  return { to_credit: sumText(rows, r => r.to_credit), events: rows.reduce((n, r) => n + creditEvents(r), 0), draft: sumText(rows, r => (r.draft ? r.draft.amount : '0')) };
}
export const reasonInvalid = (text) => !String(text || '').trim() || [...String(text)].length > 300;
export const creditQuickCount = (k, rows, counts) => (REGISTER_VIEWS[k] ? null : k === 'wont_issue' ? counts?.not_to_issue ?? null : k === 'has_draft' ? rows.filter(r => r.draft).length : rows.filter(r => !r.draft).length);
// the order hint: events still to credit (open or on the draft), the amount, the draft, the dismissal; null = show nothing
export function creditHint(res) {
  if (!res) return null;
  const events = (res.sources || []).filter(s => s.status === 'open' || s.status === 'draft').length;
  const amount = res.reconcile?.to_credit || '0.00';
  if (res.dismissal) return { kind: 'dismissed', dismissal: res.dismissal, events, amount };
  return events > 0 || cents(amount) > 0n ? { kind: 'todo', events, amount, draft: res.draft || null } : null;
}
// the register view rows: Stranded keeps the credit notes with no live invoice; text and customer filters as the worklist
export function filterRegisterView(avoirs, view, { q = '', partner_ids = [] } = {}) {
  let r = view === 'stranded' ? avoirs.filter(a => a.stranded) : avoirs;
  const s = q.trim().toLowerCase();
  if (s) r = r.filter(x => [x.operation_id, x.customer_name, x.avoir_no].some(v => String(v || '').toLowerCase().includes(s)));
  if (partner_ids.length) r = r.filter(x => partner_ids.includes(x.partner_id));
  return r;
}
